import { Injectable, Pipe } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ColorListModel } from '../../sales/models/color-list.model';
@Pipe({ name: 'ColorpaintService' })
@Injectable()
export class ColorpaintService {

  constructor(private httpClient: HttpClient) { }
  //lấy danh sách màu
  getAllColor() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/color/getAllColor";
    return this.httpClient.post(url, {})
      .map((response: Response) => {
        return response;
      });
  }

  getAllColorAsync() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/color/getAllColor";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {}).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  getAllColorByListColor(listColorId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/color/getAllColor";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        ListColorId: listColorId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }

  //lấy tỷ trọng màu
 getAllColorDensity() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorFormula/getAllColorFormula";
    return this.httpClient.post(url, {})
      .map((response: Response) => {
        return response;
      });
  } 
  //lấy phân loại màu
  getAllColorType() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorType/getAllColorType";
    return this.httpClient.post(url, {})
      .map((response: Response) => {
        return response;
      });
  }
  //lấy hộp màu
  getAllColorBox() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorBox/getAllColorBox";
    return this.httpClient.post(url, {})
      .map((response: Response) => {
        return response;
      });
  }
  //lấy danh sách nhập màu
  getAllColorImport() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/importColor/getAllImportColor";
    return this.httpClient.post(url, {})
      .map((response: Response) => {
        return response;
      });
  }
  getAllColorMix(customerId: string, colorId: string, productId: string, orderDateStart: Date, orderDateEnd: Date) {
    const url = localStorage.getItem('ApiEndPoint') + 'api/order/getAllColorMix';
    return this.httpClient.post(url, {
      CustomerId: customerId,
      ColorId: colorId,
      ProductId: productId,
      OrderDateStart: orderDateStart,
      OrderDateEnd: orderDateEnd
    })
      .map((response: Response) => {
        return <any>response;
      });
  }

  createColor(colorCode: string, colorName: string, price: number, note: string, darkColor: number) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/color/createColor";
    return this.httpClient.post(url, { 
      ColorCode: colorCode, 
      ColorName: colorName, 
      Price: price, 
      Note: note, 
      DarkColor: darkColor })
      .map((response: Response) => {
        return response;
      });
  }
  getColorByID(colorId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/color/getColorById';
    return this.httpClient.post(url, {
      ColorId: colorId,
    })
      .map((response: Response) => {
        return response;
      });
  }
  updateColor(colorId: string,colorCode: string, colorName: string, price: number, note: string, darkColor: number){
    const url = localStorage.getItem('ApiEndPoint') + '/api/color/editColorById';
    return this.httpClient.post(url, { 
      ColorId: colorId,
      ColorCode: colorCode, 
      ColorName: colorName, 
      Price: price, 
      Note: note, 
      DarkColor: darkColor })
      .map((response: Response) => {
        return response;
      });
  }
  searchColor(colorCode: string, colorName: string, price: number){
    const url = localStorage.getItem('ApiEndPoint') + '/api/color/getAllColor';
    return this.httpClient.post(url, { 
      ColorCode: colorCode, 
      ColorName: colorName, 
      Price: price, })
      .map((response: Response) => {
        return response;
      });
  }
  deleteColor(ColorId: string){
    const url = localStorage.getItem('ApiEndPoint') + '/api/color/deleteColorById';
    return this.httpClient.post(url, {
      ColorId: ColorId,
    })
      .map((response: Response) => {
        return response;
      });
  }
  searchColorType(colorTypeCode: string,colorTypeName: string){
    const url = localStorage.getItem('ApiEndPoint') + "/api/colorType/getAllColorType";
    return this.httpClient.post(url, {
      ColorTypeCode:colorTypeCode,
      ColorTypeName:colorTypeName,
    })
    .map((response: Response) => {
      return response;
    });
  }

  getColorTypeByID(ColorTypeId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/colorType/getColorTypeById';
    return this.httpClient.post(url, {
      ColorTypeId: ColorTypeId,
    })
      .map((response: Response) => {
        return response;
      });
  }
  deleteColorTypeByID(ColorTypeId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/colorType/deleteColorTypeById';
    return this.httpClient.post(url, {
      ColorTypeId: ColorTypeId,
    })
      .map((response: Response) => {
        return response;
      });
  }
  updateColorType(ColorTypeId: string, ColorTypeCode: string, ColorTypeName: string){
    const url = localStorage.getItem('ApiEndPoint') + '/api/colorType/editColorTypeById';
    return this.httpClient.post(url, { 
      ColorTypeId: ColorTypeId,
      ColorTypeCode: ColorTypeCode, 
      ColorTypeName: ColorTypeName, 
    })
      .map((response: Response) => {
        return response;
      });
  }

  createColorType(ColorTypeCode: string, ColorTypeName: string){
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorType/createColorType";
    return this.httpClient.post(url, {
      ColorTypeCode: ColorTypeCode,
      ColorTypeName: ColorTypeName,
    })
      .map((response: Response) => {
        return response;
      });
  }

  createColorBox(ColorBoxCode: string, ColorBoxName: string, NumberYInBox: number, NumberOfBarY: number, TotalBar: number){
    let url = localStorage.getItem('ApiEndPoint') + "/api/colorBox/createColorBox";
    return this.httpClient.post(url, {
      ColorBoxCode:ColorBoxCode,
      ColorBoxName: ColorBoxName,
      NumberYInBox: NumberYInBox,
      NumberOfBarY: NumberOfBarY,
      TotalBar: TotalBar,
    })
      .map((response: Response) => {
        return response;
      });
  }

  getColorBoxByID(colorBoxId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/colorBox/getColorBoxById';
    return this.httpClient.post(url, {
      ColorBoxId: colorBoxId,
    })
      .map((response: Response) => {
        return response;
      });
  }

  updateColorBox(ColorBoxId: string, ColorBoxCode: string, ColorBoxName: string, NumberYInBox: number, NumberOfBarY: number,TotalBar: number){
    const url = localStorage.getItem('ApiEndPoint') + '/api/colorBox/editColorBoxById';
    return this.httpClient.post(url, { 
      ColorBoxId: ColorBoxId,
      ColorBoxCode: ColorBoxCode, 
      ColorBoxName: ColorBoxName, 
      NumberYInBox: NumberYInBox, 
      NumberOfBarY: NumberOfBarY, 
      TotalBar: TotalBar,
    })
      .map((response: Response) => {
        return response;
      });
  }
  deleteColorBox(ColorBoxId: string){
    const url = localStorage.getItem('ApiEndPoint') + '/api/colorBox/deleteColorBoxById';
    return this.httpClient.post(url, { 
      ColorBoxId: ColorBoxId,
    })
      .map((response: Response) => {
        return response;
      });
  }

  getDensityByID(ColorFormulaId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/colorFormula/getColorFormulaById';
    return this.httpClient.post(url, {
      ColorFormulaId: ColorFormulaId,
    })
      .map((response: Response) => {
        return response;
      });
  }

  updateDensity(ColorFormulaId: string, A: number, B: number, C: number, D: number, E: number, F: number, I: number, K: number, L: number, R: number, T: number, V:number){
    const url = localStorage.getItem('ApiEndPoint') + '/api/colorFormula/editColorFormulaById';
    return this.httpClient.post(url, { 
      ColorFormulaId: ColorFormulaId,
      A: A, 
      B: B, 
      C: C, 
      D: D, 
      E: E,
      F: F,
      I: I,
      K: K,
      L: L,
      R: R,
      T: T,
      V: V,
    })
      .map((response: Response) => {
        return response;
      });
  }

  createColorImport(ColorTypeId: string, ColorBoxId: string, TotalBar: number, NumberBox: number, TotalBarImport: number){
    let url = localStorage.getItem('ApiEndPoint') + "/api/importColor/createImportColor";
    return this.httpClient.post(url, {
      ColorTypeId:ColorTypeId,
      ColorBoxId: ColorBoxId,
      TotalBar: TotalBar,
      NumberBox: NumberBox,
      TotalBarImport: TotalBarImport,
    })
      .map((response: Response) => {
        return response;
      });
  }
  
  getColorImportByID(ImportColorId: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/importColor/getImportColorById';
    return this.httpClient.post(url, {
      ImportColorId: ImportColorId,
    })
      .map((response: Response) => {
        return response;
      });
  }
  deleteImportColorById(ImportColorId: string){
    const url = localStorage.getItem('ApiEndPoint') + '/api/importColor/deleteImportColorById';
    return this.httpClient.post(url, {
      ImportColorId: ImportColorId,
    })
      .map((response: Response) => {
        return response;
      });
  }
  editImportColorById(ImportColorId: string,ColorTypeId: string, ColorBoxId: string, TotalBar: number, NumberBox: number, TotalBarImport: number){
    let url = localStorage.getItem('ApiEndPoint') + "/api/importColor/editImportColorById";
    return this.httpClient.post(url, {
      ImportColorId: ImportColorId,
      ColorTypeId:ColorTypeId,
      ColorBoxId: ColorBoxId,
      TotalBar: TotalBar,
      NumberBox: NumberBox,
      TotalBarImport: TotalBarImport,
    })
      .map((response: Response) => {
        return response;
      });
  }

  /*API Lấy danh sách màu ở popup tạo đơn hàng (chỉ lấy những trường cần dùng để tăng hiệu suất)*/
  getColorByCreateOrder(listColorId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/color/getColorByCreateOrder";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {
        ListColorId: listColorId
      }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/colorpaint.service.ts